import useTable from '../../../hooks/useTable';
import { Table } from '../../Table';
import { TableComponentProps } from '../types';

const columnLables = {
  typical_position_size: {
    name: 'Position size type',
    order: 113
  }
};

export function TypicalPositionSize({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useTable({
    data: funds[currentDataKey]?.fund_data?.TYPICAL_POSITION_SIZE,
    onChangeFund,
    schema: schema.TYPICAL_POSITION_SIZE,
    isStaticTemplate,
    requiredFields:
      funds[currentDataKey]?.required_tables?.TYPICAL_POSITION_SIZE?.field_names || [],
    tableName: 'TYPICAL_POSITION_SIZE',
    columnLables,
    isMultiFunds,
    funds
  });

  return (
    <Table
      id="reporttables-typical-position-size-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
    />
  );
}
